import Api from "./PreApiHandler";
import store from "@/store/store";

const FeedbackService = {
  async send(message, source = 'sidebar', wantReply = false) {
    const botKey = store.state.init?.current_bot?.key || null
    return Api.sendRequest({
      method: 'post',
      path: 'app-feedback',
      body: { message, source, bot_key: botKey, want_reply: !!wantReply },
    })
  },
}

export default FeedbackService
